module.exports = __webpack_public_path__ + "img/21.cfdf2721.png";